import { toPhone } from '@constants/regexp';
import {
  ChangeEvent, ReactNode, useMemo, useState,
} from 'react';

import GiftOrderContext, { GiftFormProps } from './GiftOrderContext';

interface Props {
    children: ReactNode;
}

function GiftOrderProvider({ children }:Props) {
  const [state, setState] = useState<GiftFormProps>({
    userPhone: '',
    userName: '',
    message: '',
    giftRecipients: [],
  });
  const enabled = useMemo<boolean>(() => {
    const {
      userName, userPhone, giftRecipients,
    } = state;
    return !!userName && !!userPhone && (giftRecipients.length > 0);
  }, [state]);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name } = e.currentTarget;
    let newValue = e.target.value;
    if (name === 'userPhone') {
      newValue = toPhone(newValue);
    }
    setState((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };
  return (
        <GiftOrderContext value={{
          state, setState, handleChange, enabled,
        }}>
            {children}
        </GiftOrderContext>
  );
}

export default GiftOrderProvider;
